<mat-dialog-actions class="dialog-footer">
  <span class="dialog-footer__note">
    @if (showRequiredNote) {
      <span class="dialog-footer__required">*</span> Required field
    }
  </span>
  <ng-content></ng-content>
</mat-dialog-actions>
